import {
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import { UserGroupIndexResource, UserGroupRequest, UserGroupUpdateResource } from "../types/userGroup";

const baseKey = "user-groups";
export const userGroupService = {
	...withIndexEndpoint<UserGroupIndexResource>([baseKey]),
	...withShowEndpoint<UserGroupUpdateResource>([baseKey]),
	...withStoreEndpoint<UserGroupRequest>([baseKey]),
	...withUpdateEndpoint<UserGroupRequest>([baseKey]),
	...withDestroyEndpoint([baseKey]),
};
